__webpack_require__.p = "/chainguard-pharma-dashboard/";